// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1g_n1","sendOtp":"AuthorizeToLogin_sendOtp__2cs7O"};